import { render, staticRenderFns } from "./FbRecipientSearch.vue?vue&type=template&id=0a30db2c&"
import script from "./FbRecipientSearch.vue?vue&type=script&lang=js&"
export * from "./FbRecipientSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports